import type { RouteRecordRaw } from 'vue-router'
import {
  collectRouteCandidates,
  toAnyPermission,
} from '@/config/businessRoutePermissions'
import { legacyTenantRedirect, maybeRouteName } from './tenantScoped'

const createCollectChildren = (withNames: boolean): RouteRecordRaw[] => [
  {
    path: 'dashboard',
    ...maybeRouteName(withNames, 'collect-dashboard'),
    component: () => import('@/views/collect/CollectDashboard.vue'),
    meta: { title: '采集中心工作台', permission: 'collect:center:view' },
  },
  {
    path: 'sources',
    ...maybeRouteName(withNames, 'collect-sources'),
    component: () => import('@/views/collect/CollectSources.vue'),
    meta: { title: '数据源管理', permission: 'collect:source:view' },
  },
  {
    path: 'agents',
    ...maybeRouteName(withNames, 'collect-agents'),
    component: () => import('@/views/collect/CollectAgents.vue'),
    meta: { title: 'Agent 管理', permission: 'collect:agent:view' },
  },
  {
    path: 'metrics',
    ...maybeRouteName(withNames, 'collect-metrics'),
    component: () => import('@/views/collect/CollectMetrics.vue'),
    meta: { title: '指标管理', permission: 'collect:metric:view' },
  },
]

const createCollectRoute = (path: string, defaultRouteBasePath: string, withNames: boolean): RouteRecordRaw => ({
  path,
  component: () => import('@/views/collect/CollectLayout.vue'),
  ...(withNames ? {} : { beforeEnter: legacyTenantRedirect }),
  meta: {
    permission: toAnyPermission(collectRouteCandidates),
    defaultRouteBasePath,
    defaultRouteCandidates: collectRouteCandidates,
    ...(!withNames ? { legacyTenantRedirect: true } : {}),
  },
  children: createCollectChildren(withNames)
})

const collectRoutes: RouteRecordRaw[] = [
  createCollectRoute('t/:tenantCode/collect', '/t/:tenantCode/collect', true),
  createCollectRoute('collect', '/collect', false),
]

export default collectRoutes
